import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = [
    {
      title: "Shop",
      links: [
        { name: "All Categories", path: "/category-pages" },
        { name: "Smartphones", path: "/category-pages" },
        { name: "Laptops", path: "/category-pages" },
        { name: "Audio", path: "/category-pages" },
        { name: "Accessories", path: "/category-pages" },
        { name: "Smart Home", path: "/category-pages" }
      ]
    },
    {
      title: "Account",
      links: [
        { name: "My Dashboard", path: "/user-dashboard" },
        { name: "Order History", path: "/user-dashboard" },
        { name: "Shopping Cart", path: "/shopping-cart" },
        { name: "Wishlist", path: "/user-dashboard" },
        { name: "Account Settings", path: "/user-dashboard" }
      ]
    },
    {
      title: "Support",
      links: [
        { name: "Help Center", path: "#" },
        { name: "Contact Us", path: "#" },
        { name: "Shipping Info", path: "#" },
        { name: "Returns", path: "#" },
        { name: "Warranty", path: "#" },
        { name: "FAQ", path: "#" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "About Us", path: "#" },
        { name: "Careers", path: "#" },
        { name: "Press", path: "#" },
        { name: "Investors", path: "#" },
        { name: "Store Locations", path: "#" },
        { name: "Admin Portal", path: "/admin-dashboard" }
      ]
    }
  ];

  const socialLinks = [
    { name: "Facebook", icon: "Facebook", url: "#" },
    { name: "Twitter", icon: "Twitter", url: "#" },
    { name: "Instagram", icon: "Instagram", url: "#" },
    { name: "LinkedIn", icon: "Linkedin", url: "#" },
    { name: "YouTube", icon: "Youtube", url: "#" }
  ];

  const paymentMethods = [
    { name: "Visa", icon: "CreditCard" },
    { name: "Mastercard", icon: "CreditCard" },
    { name: "PayPal", icon: "Wallet" },
    { name: "Apple Pay", icon: "Smartphone" },
    { name: "Google Pay", icon: "Smartphone" }
  ];

  const trustBadges = [
    { name: "SSL Secured", icon: "Shield", color: "text-success" },
    { name: "24/7 Support", icon: "Headphones", color: "text-primary" },
    { name: "Fast Shipping", icon: "Truck", color: "text-secondary" },
    { name: "Money Back", icon: "RotateCcw", color: "text-accent" }
  ];

  return (
    <footer className="bg-gradient-to-b from-card to-background border-t border-border">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-6 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2 space-y-6">
            <Link to="/homepage" className="flex items-center space-x-3 group">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center trust-seal">
                  <Icon name="Zap" size={28} color="white" strokeWidth={2.5} />
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-secondary/20 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold command-text bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                  ElectroShop Pro
                </span>
                <span className="text-xs text-muted-foreground font-mono tracking-wider">
                  TECH COMMAND CENTER
                </span>
              </div>
            </Link>

            <p className="text-muted-foreground leading-relaxed max-w-md">
              Your trusted destination for premium electronics. We combine cutting-edge technology 
              with transparent business practices to deliver exceptional customer experiences.
            </p>

            {/* Trust Badges */}
            <div className="grid grid-cols-2 gap-4">
              {trustBadges?.map((badge, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center space-x-2 p-3 bg-background/50 border border-border rounded-lg"
                >
                  <Icon name={badge?.icon} size={16} className={badge?.color} />
                  <span className="text-sm text-muted-foreground">{badge?.name}</span>
                </motion.div>
              ))}
            </div>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Icon name="Phone" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground"><strong>+213 5 40 31 66 04</strong></span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Phone" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground">+213 6 60 81 82 72 (Admissions)</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Clock" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground">Mon-Fri: 8:00 AM - 6:00 PM</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Mail" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground"><strong>aymenbouz447@gmail.com</strong></span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Mail" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground">chouaib.boubou2@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="MessageCircle" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground">Response within 24 hours</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="Building" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground"><strong>Friends School Constantine</strong></span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="MapPin" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground">El khroub El Hayat, Constantine</span>
              </div>
              <div className="flex items-center space-x-3">
                <Icon name="MapPin" size={16} className="text-primary" />
                <span className="text-sm text-muted-foreground">Constantine, Algeria</span>
              </div>
            </div>
          </div>

          {/* Footer Links */}
          {footerSections?.map((section, index) => (
            <div key={index} className="space-y-6">
              <h3 className="text-lg font-semibold text-foreground">{section?.title}</h3>
              <ul className="space-y-3">
                {section?.links?.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link?.path}
                      className="text-muted-foreground hover:text-primary transition-colors duration-200 text-sm"
                    >
                      {link?.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter Signup */}
        <div className="mt-16 pt-8 border-t border-border">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-xl font-bold text-foreground mb-2">Stay Updated</h3>
              <p className="text-muted-foreground">
                Subscribe to get special offers, tech news, and exclusive deals.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-input border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
              />
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium text-sm trust-seal"
              >
                Subscribe
              </motion.button>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Footer */}
      <div className="border-t border-border bg-background/50">
        <div className="container mx-auto px-6 py-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0">
            {/* Copyright */}
            <div className="text-center lg:text-left">
              <p className="text-sm text-muted-foreground">
                © {currentYear} ElectroShop Pro. All rights reserved.
              </p>
              <div className="flex items-center justify-center lg:justify-start space-x-4 mt-2">
                <Link to="#" className="text-xs text-muted-foreground hover:text-primary">
                  Privacy Policy
                </Link>
                <span className="text-muted-foreground">•</span>
                <Link to="#" className="text-xs text-muted-foreground hover:text-primary">
                  Terms of Service
                </Link>
                <span className="text-muted-foreground">•</span>
                <Link to="#" className="text-xs text-muted-foreground hover:text-primary">
                  Cookie Policy
                </Link>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex items-center space-x-4">
              <span className="text-sm text-muted-foreground">Follow us:</span>
              {socialLinks?.map((social, index) => (
                <motion.a
                  key={index}
                  href={social?.url}
                  whileHover={{ scale: 1.1, y: -2 }}
                  className="p-2 bg-card border border-border rounded-lg hover:bg-primary hover:text-primary-foreground transition-colors"
                >
                  <Icon name={social?.icon} size={16} />
                </motion.a>
              ))}
            </div>

            {/* Payment Methods */}
            <div className="flex items-center space-x-4">
              <span className="text-sm text-muted-foreground">We accept:</span>
              <div className="flex items-center space-x-2">
                {paymentMethods?.map((method, index) => (
                  <div
                    key={index}
                    className="p-2 bg-card border border-border rounded-lg"
                    title={method?.name}
                  >
                    <Icon name={method?.icon} size={16} className="text-muted-foreground" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Business Info */}
          <div className="mt-8 pt-6 border-t border-border text-center">
            <div className="flex flex-wrap justify-center items-center gap-6 text-xs text-muted-foreground">
              <div className="flex items-center space-x-2">
                <Icon name="Building" size={14} />
                <span>ElectroShop Pro LLC</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="FileText" size={14} />
                <span>Business License: #ES-2024-001</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Globe" size={14} />
                <span>Serving 25+ Countries Worldwide</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="inventory-pulse high"></div>
                <span>Real-time Inventory System</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;